// removed by extract-text-webpack-plugin
module.exports = {"nav-outlet-link":"app-components-NavOutlet-__style___316Tq","text-block-center":"app-components-NavOutlet-__style___339a7","nav-outlet-wrapper":"app-components-NavOutlet-__style___3qYg-"};


//////////////////
// WEBPACK FOOTER
// ./app/components/NavOutlet/style.css
// module id = 1981
// module chunks = 0